import usePersistStore from './usePersistStore';

export const usePersistActions = () =>
  usePersistStore((state) => state.actions);
export const useGetCreatingToken = () =>
  usePersistStore((state) => state.creatingToken);
export const useGetRpcUrl = () => usePersistStore((state) => state.rpcUrl);
export const useGetRpcKey = () => usePersistStore((state) => state.rpcKey);
export const useGetRpcError = () => usePersistStore((state) => state.rpcError);
export const useGetSlippageMeme = () =>
  usePersistStore((state) => state.memeSlippage);
export const useGetSlippageAgent = () =>
  usePersistStore((state) => state.agentSlippage);
export const useGetEnableDisclaimer = () =>
  usePersistStore((state) => state.confirmDisclaimer);
export const useGetCurrentNetwork = () =>
  usePersistStore((state) => state.currentNetwork);
export const useGetEnableLockToken = () =>
  usePersistStore((state) => state.confirmLock);
export const useGetEnableLockTokenList = () =>
  usePersistStore((state) => state.confirmLockUserList);
